import {
  Component,
  inject,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReportsUtilsService } from '@app/modules/reports/services/reports-utils.service';
import { ReportsState } from '@app/modules/reports/store/reports.state';
import { ExtendedReport } from '@app/modules/reports/types/report.types';
import { Util } from '@core/utils/core.util';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionsLocation,
  DataTableActionType,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { Observable, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-report-search-results',
  imports: [TranslatePipe, DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './report-search-results.component.html',
})
export class ReportSearchResultsComponent implements OnInit {
  private dialogRef = inject(NgbActiveModal);
  private reportsUtilsService = inject(ReportsUtilsService);
  private store = inject(Store);

  public reportIds = signal<string[]>([]);
  protected isLoading = signal(true);

  protected dataTableConfiguration: DataTableConfiguration;

  private rows$: Observable<ExtendedReport[]>;

  ngOnInit(): void {
    this.rows$ = this.store.select(ReportsState.getReportsByIds).pipe(
      switchMap((getReportsByIds) =>
        this.reportsUtilsService.getExtendedReports(
          getReportsByIds(this.reportIds()),
          { pii: { partner: true, product: true } }
        )
      ),
      tap(() => this.isLoading.set(false))
    );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      actionsClasses: 'text-end',
      columns: [
        {
          label: 'reports.search.columns.barcode',
          invoke: {
            objectReference: {
              fn: (report: ExtendedReport) =>
                Util.PropertiesToObject(report.properties)?.kitid,
            },
            name: 'fn',
            args: [],
          },
        },
        {
          label: 'reports.search.columns.version',
          property: 'version',
        },
        {
          label: 'reports.search.columns.partner',
          property: 'productInventoryItem.partner.name',
        },
        {
          label: 'reports.search.columns.product',
          property: 'productInventoryItem.product.name',
        },
      ],
      singleActions: [
        {
          name: 'reports.search.actions.openReportDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: this.openReportDetails.bind(this),
        },
      ],
      rows$: this.rows$,
    };
  }

  private openReportDetails(event: MouseEvent, report: ExtendedReport) {
    this.reportsUtilsService.openReportDetailsDialog(report.id);
    this.dismiss();
  }

  dismiss() {
    this.dialogRef.close();
  }
}
